export const KPI_CARD = {
  "Cardreport.Kpicard.Trendicon.Trendhigh.Color": {
    ref: "Color.Success.500"
  },
  "Cardreport.Kpicard.Trendicon.Trendmedium.Color": {
    ref: "Color.Warning.500"
  },
  "Cardreport.Kpicard.Trendicon.Trendlow.Color": {
    ref: "Color.Error.500"
  },
  "Cardreport.Kpicard.Trendicon.Size": {
    defaultValue: "20px"
  },
  "Cardreport.Kpicard.Trendicon.Padding.Top": {
    defaultValue: "4px"
  },
  "Cardreport.Kpicard.Trendicon.Padding.Bottom": {
    defaultValue: "4px"
  },
  "Cardreport.Kpicard.Trendicon.Padding.Left": {
    defaultValue: "4px"
  },
  "Cardreport.Kpicard.Trendicon.Padding.Right": {
    defaultValue: "4px"
  },
  "Cardreport.Kpicard.Value.Font.Style": {
    defaultValue: "normal"
  },
  "Cardreport.Kpicard.Value.Text.Decoration": {
    defaultValue: "normal"
  },
  "Cardreport.Kpicard.Kpivalues.Font.Style": {
    defaultValue: "normal"
  },
  "Cardreport.Kpicard.Kpivalues.Text.Decoration": {
    defaultValue: "normal"
  },
  "Cardreport.Kpicard.Label.Font.Style": {
    defaultValue: "normal"
  },
  "Cardreport.Kpicard.Label.Text.Decoration": {
    defaultValue: "normal"
  },
  "Cardreport.Kpicard.Kpilabels.Font.Style": {
    defaultValue: "normal"
  },
  "Cardreport.Kpicard.Kpilabels.Text.Decoration": {
    defaultValue: "normal"
  },
  "Cardreport.Kpicard.Value.Color": {
    ref: "Color.Gray.900"
  },
  "Cardreport.Kpicard.Value.Font.Size": {
    ref: "Font.Size.24"
  },
  "Cardreport.Kpicard.Value.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },
  "Cardreport.Kpicard.Value.Padding.Top": {
    defaultValue: "0px"
  },
  "Cardreport.Kpicard.Value.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Cardreport.Kpicard.Value.Padding.Left": {
    defaultValue: "0px"
  },
  "Cardreport.Kpicard.Value.Padding.Right": {
    defaultValue: "0px"
  },
  "Cardreport.Kpicard.Label.Color": {
    ref: "Color.Gray.600"
  },
  "Cardreport.Kpicard.Label.Font.Size": {
    ref: "Font.Size.12"
  },
  "Cardreport.Kpicard.Label.Font.Weight": {
    ref: "Font.Weight.Medium"
  },
  "Cardreport.Kpicard.Label.Padding.Top": {
    defaultValue: "0px"
  },
  "Cardreport.Kpicard.Label.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Cardreport.Kpicard.Label.Padding.Left": {
    defaultValue: "0px"
  },
  "Cardreport.Kpicard.Label.Padding.Right": {
    defaultValue: "0px"
  },
  "Cardreport.Kpicard.Kpivalues.Color": {
    ref: "Color.Gray.900"
  },
  "Cardreport.Kpicard.Kpivalues.Font.Size": {
    ref: "Font.Size.14"
  },
  "Cardreport.Kpicard.Kpivalues.Font.Weight": {
    ref: "Font.Weight.SemiBold"
  },
  "Cardreport.Kpicard.Kpivalues.Padding.Top": {
    defaultValue: "0px"
  },
  "Cardreport.Kpicard.Kpivalues.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Cardreport.Kpicard.Kpivalues.Padding.Left": {
    defaultValue: "0px"
  },
  "Cardreport.Kpicard.Kpivalues.Padding.Right": {
    defaultValue: "0px"
  },
  "Cardreport.Kpicard.Kpilabels.Color": {
    ref: "Color.Gray.600"
  },
  "Cardreport.Kpicard.Kpilabels.Font.Size": {
    ref: "Font.Size.10"
  },
  "Cardreport.Kpicard.Kpilabels.Font.Weight": {
    ref: "Font.Weight.Medium"
  },
  "Cardreport.Kpicard.Kpilabels.Padding.Top": {
    defaultValue: "0px"
  },
  "Cardreport.Kpicard.Kpilabels.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Cardreport.Kpicard.Kpilabels.Padding.Left": {
    defaultValue: "0px"
  },
  "Cardreport.Kpicard.Kpilabels.Padding.Right": {
    defaultValue: "0px"
  },
  "Cardreport.Kpicard.Kpis.Horizontal.Gap": {
    defaultValue: "20px"
  },
  "Cardreport.Kpicard.Content.Vertical.Gap": {
    defaultValue: "0px"
  }
};
